<template>
    <div class="modal fade show" tabindex="-1" style="display: block;z-index: calc(var(--bs-modal-zindex) + 10); margin-top: 2rem;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header" v-if="title" style="padding: 1.1rem 2rem 0 1.1rem;">
                    <h3 class="modal-title">{{ title }}</h3>
                    <button type="button" class="btn-close" aria-label="Close" @click="emit('cancel')"></button>
                </div>
                <div class="modal-body" style="padding: 1.3rem;">
                    <span v-html="message"></span>
                </div>
                <div class="modal-footer" style="padding: 0.65rem;">
                    <AppButton btnClass="btn-white btn-sm" @click="emit('cancel')">{{ $t(cancelButtonText) }}</AppButton>
                    <AppButton btnClass="btn-primary btn-sm" @click="emit('confirm')">{{ $t(confirmButtonText) }}</AppButton>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index: calc(var(--bs-backdrop-zindex) + 10);"></div>
</template>

<script setup>
import {trans as $t} from "@/vue/composables/missingTranslations";
import AppButton from "@/vue/shared/AppButton.vue";

const emit = defineEmits(["confirm", "cancel"]);

const props = defineProps({
    title: {
        type: String,
        default: null
    },
    message: {
        type: String,
        default: null
    },
    confirmButtonText: {
        type: String,
        default: "Ok"
    },
    cancelButtonText: {
        type: String,
        default: "Cancel"
    }
});
</script>
